import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container invoice-2" }
const _hoisted_2 = { class: "row" }

import { defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'IndexInvoiceThree',
  setup(__props) {

const Card3 = defineAsyncComponent(() => import("@/components/common/card/CardData3.vue"))
const InvoicePageThree = defineAsyncComponent(() => import("@/components/theme/ecommerce/invoice/invoice3/InvoicePageThree.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "ECommerce",
      mains: "Invoice-3",
      title: "Invoice-3"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(Card3), { colClass: "col-sm-12" }, {
          default: _withCtx(() => [
            _createVNode(_unref(InvoicePageThree))
          ]),
          _: 1
        })
      ])
    ])
  ], 64))
}
}

})